import { render } from "./HomeBaseSignups.vue?vue&type=template&id=15b0a764"
import script from "./HomeBaseSignups.vue?vue&type=script&lang=js"
export * from "./HomeBaseSignups.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__